import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import Swal from 'sweetalert2';
import {
    Button,
    Col,
    Collapse,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    FormGroup,
    Input,
    Label,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    Row,
    UncontrolledDropdown
} from 'reactstrap';
import { authActions, relatorioAction, fazendaAction } from '../_actions';
import { ModalAnimaisFazenda } from './modalAnimaisFazenda';
import { ModalProducoesPeriodo } from './modalProducoesPeriodo';
import { ModalTanquesPeriodo } from './modalTanquesPeriodo';
import { ModalProducoesLotePeriodo } from './modalProducoesLotePeriodo';
import Select from 'react-select';
import { ModalAnimaisInseminacoes } from './modalAnimaisInseminacoes';
import { ModalAnimaisPartos } from './modalAnimaisPartos';
import { ModalSelectEmpresa } from './modalSelectEmpresa';
import { ModalNascimentos } from './modalNascimentos';
import { ModalRelatorioVisitas } from './modalRelatorioVisitas';
import { ModalFichaAnimal } from './modalFichaAnimal';

const NavBar = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const [openModalSelectFazenda, setOpenModalSelectFazenda] = useState(false);
    const [openModalAnimaisAtivos, setOpenModalAnimaisAtivos] = useState(false);
    const [openModalAnimaisDescartados, setOpenModalAnimaisDescartados] = useState(false);
    const [openModalAnimaisSaida, setOpenModalAnimaisSaida] = useState(false);
    const [openModalSelectEmpresa, setOpenModalSelectEmpresa] = useState(false);
    const [openModalProducoes, setOpenModalProducoes] = useState(false);
    const [openModalTanques, setOpenModalTanques] = useState(false);
    const [openModalAnimaisInseminacoes, setOpenModalAnimaisInseminacoes] = useState(false);
    const [openModalAnimaisPartos, setOpenModalAnimaisPartos] = useState(false);
    const [openModalProducoesLote, setOpenModalProducoesLote] = useState(false);
    const [openModalNascimentos, setOpenModalNascimentos] = useState(false);
    const [openModalRelatorioVisitas, setOpenModalRelatorioVisitas] = useState(false);
    const [openModalInventario, setOpenModalInventario] = useState(false);
    const [openModalFichaAnimal, setOpenModalFichaAnimal] = useState(false);
    const [filtroDataInventario, setFiltroDataInventario] = useState('entrada_saida');
    const [dataPosicao, setDataPosicao] = useState('');
    const [fazendasMaisDeUmAno, setFazendasMaisDeUmAno] = useState(false);
    const [dataInicio, setDataInicio] = useState('');
    const [dataFim, setDataFim] = useState('');
    const [fazendaSelecionada, setFazendaSelecionada] = useState(0);

    // ACASALAMENTOS
    const [openModalImportAcasalamentos, setOpenModalImportAcasalamentos] = useState(false);
    const [openModalImportArquivo, setOpenModalImportArquivo] = useState(false);
    const [selectedImportFazenda, setSelectedImportFazenda] = useState(0);
    const [selectedImportFile, setSelectedImportFile] = useState(null);

    // ANIMAIS DESCARTADOS
    const [openModalImportAnimaisDescartados, setOpenModalImportAnimaisDescartados] = useState(false);
    const [openModalImportAnimaisArquivo, setOpenModalImportAnimaisArquivo] = useState(false);
    const [selectedImportFazendaAnimais, setSelectedImportFazendaAnimais] = useState(0);
    const [selectedImportFileAnimais, setSelectedImportFileAnimais] = useState(null);

    // CCS
    const [openModalImportCcs, setOpenModalImportCcs] = useState(false);
    const [openModalImportCcsArquivo, setOpenModalImportCcsArquivo] = useState(false);
    const [selectedImportFazendaCcs, setSelectedImportFazendaCcs] = useState(0);
    const [selectedImportFileCcs, setSelectedImportFileCcs] = useState(null);

    // CULTURA
    const [openModalImportCultura, setOpenModalImportCultura] = useState(false);
    const [openModalImportCulturaArquivo, setOpenModalImportCulturaArquivo] = useState(false);
    const [selectedImportFazendaCultura, setSelectedImportFazendaCultura] = useState(0);
    const [selectedImportFileCultura, setSelectedImportFileCultura] = useState(null);

    // INSEMINAÇÕES
    const [openModalImportInseminacoes, setOpenModalImportInseminacoes] = useState(false);
    const [openModalImportInseminacoesArquivo, setOpenModalImportInseminacoesArquivo] = useState(false);
    const [selectedImportFazendaInseminacoes, setSelectedImportFazendaInseminacoes] = useState(0);
    const [selectedImportFileInseminacoes, setSelectedImportFileInseminacoes] = useState(null);

    // PARTOS
    const [openModalImportPartos, setOpenModalImportPartos] = useState(false);
    const [openModalImportPartosArquivo, setOpenModalImportPartosArquivo] = useState(false);
    const [selectedImportFazendaPartos, setSelectedImportFazendaPartos] = useState(0);
    const [selectedImportFilePartos, setSelectedImportFilePartos] = useState(null);

    // PESAGENS
    const [openModalImportPesagens, setOpenModalImportPesagens] = useState(false);
    const [openModalImportPesagensArquivo, setOpenModalImportPesagensArquivo] = useState(false);
    const [selectedImportFazendaPesagens, setSelectedImportFazendaPesagens] = useState(0);
    const [selectedImportFilePesagens, setSelectedImportFilePesagens] = useState(null);

    // PRODUÇÕES
    const [openModalImportProducao, setOpenModalImportProducao] = useState(false);
    const [openModalImportProducaoArquivo, setOpenModalImportProducaoArquivo] = useState(false);
    const [selectedImportFazendaProducao, setSelectedImportFazendaProducao] = useState(0);
    const [selectedImportFileProducao, setSelectedImportFileProducao] = useState(null);

    // SECAGENS
    const [openModalImportSecagens, setOpenModalImportSecagens] = useState(false);
    const [openModalImportSecagensArquivo, setOpenModalImportSecagensArquivo] = useState(false);
    const [selectedImportFazendaSecagens, setSelectedImportFazendaSecagens] = useState(0);
    const [selectedImportFileSecagens, setSelectedImportFileSecagens] = useState(null);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        setDataPosicao('');
        var data = new Date();
        var dia = String(data.getDate()).padStart(2, '0');
        var mes = String(data.getMonth() + 1).padStart(2, '0');
        var ano = data.getFullYear();
        setDataPosicao(ano + "-" + mes + "-" + dia);

    }, [openModalAnimaisAtivos])

    const toggle = () => setIsOpen(!isOpen);

    useEffect(() => {

        var data_hoje = new Date().getTime();

        if (localStorage.getItem('expire') === undefined || localStorage.getItem('expire') < data_hoje) {
            navigate('/');
        }
    }, [navigate]);

    useEffect(() => {
        if (openModalAnimaisDescartados || openModalAnimaisSaida || openModalInventario) {
            dispatch(fazendaAction.getFazendaSelect());
        }
    }, [openModalAnimaisDescartados, openModalAnimaisSaida, openModalInventario, dispatch]);

    // carregar lista de fazendas quando abrir qualquer modal de importação
    useEffect(() => {
        if (
            openModalImportAcasalamentos || openModalImportArquivo ||
            openModalImportAnimaisDescartados || openModalImportAnimaisArquivo ||
            openModalImportCcs || openModalImportCcsArquivo ||
            openModalImportCultura || openModalImportCulturaArquivo ||
            openModalImportInseminacoes || openModalImportInseminacoesArquivo ||
            openModalImportPartos || openModalImportPartosArquivo ||
            openModalImportPesagens || openModalImportPesagensArquivo ||
            openModalImportProducao || openModalImportProducaoArquivo ||
            openModalImportSecagens || openModalImportSecagensArquivo
        ) {
            dispatch(fazendaAction.getFazendaSelect());
        }
    }, [
        openModalImportAcasalamentos, openModalImportArquivo,
        openModalImportAnimaisDescartados, openModalImportAnimaisArquivo,
        openModalImportCcs, openModalImportCcsArquivo,
        openModalImportCultura, openModalImportCulturaArquivo,
        openModalImportInseminacoes, openModalImportInseminacoesArquivo,
        openModalImportPartos, openModalImportPartosArquivo,
        openModalImportPesagens, openModalImportPesagensArquivo,
        openModalImportProducao, openModalImportProducaoArquivo,
        openModalImportSecagens, openModalImportSecagensArquivo,
        dispatch
    ]);

    const handleGerarRelatorio = () => {
        let payload = { tipo_relatorio: "F" };
        dispatch(relatorioAction.getRelatorio(payload, true));
    }

    const handleOpenModalSelectFazenda = () => setOpenModalSelectFazenda(true);
    const handleCloseModalSelectFazenda = () => setOpenModalSelectFazenda(false);
    const handleOpenModalAnimaisAtivos = () => setOpenModalAnimaisAtivos(true);
    const handleCloseModalAnimaisAtivos = () => setOpenModalAnimaisAtivos(false);
    const handleOpenModalAnimaisDescartados = () => setOpenModalAnimaisDescartados(true);
    const handleCloseModalAnimaisDescartados = () => setOpenModalAnimaisDescartados(false);
    const handleOpenModalAnimaisSaida = () => setOpenModalAnimaisSaida(true);
    const handleCloseModalAnimaisSaida = () => setOpenModalAnimaisSaida(false);
    const handleOpenModalInventario = () => setOpenModalInventario(true);
    const handleCloseModalInventario = () => setOpenModalInventario(false);
    const handleOpenModalFichaAnimal = () => setOpenModalFichaAnimal(true);
    const handleCloseModalFichaAnimal = () => setOpenModalFichaAnimal(false);

    const handleOpenModalSelectEmpresa = () => setOpenModalSelectEmpresa(true);
    const handleCloseModalSelectEmpresa = () => setOpenModalSelectEmpresa(false);
    const handleOpenModalProducoes = () => setOpenModalProducoes(true);
    const handleOpenModalTanques = () => setOpenModalTanques(true);
    const handleOpenModalProducoesLote = () => setOpenModalProducoesLote(true);
    const handleOpenModalNascimentos = () => setOpenModalNascimentos(true);
    const handleCloseModalProducoes = () => setOpenModalProducoes(false);
    const handleCloseModalTanques = () => setOpenModalTanques(false);
    const handleCloseModalProducoesLote = () => setOpenModalProducoesLote(false);
    const handleCloseModalNascimentos = () => setOpenModalNascimentos(false);
    const handleOpenModalRelatorioVisitas = () => setOpenModalRelatorioVisitas(true);
    const handleCloseModalRelatorioVisitas = () => setOpenModalRelatorioVisitas(false);

    const handleOpenModalAnimaisInseminacoes = () => setOpenModalAnimaisInseminacoes(true);
    const handleOpenModalAnimaisPartos = () => setOpenModalAnimaisPartos(true);
    const handleCloseModalAnimaisPartos = () => setOpenModalAnimaisPartos(false);
    const handleCloseModalAnimaisInseminacoes = () => setOpenModalAnimaisInseminacoes(false);

    const handleValidation = () => {
        var valid = true; var errors = '';
        if (!dataPosicao) { valid = false; errors += '<li style="float:left;">Informe uma data de posição!</li><br>'; }
        if (!valid) {
            Swal.fire({ icon: 'warning', title: 'Erros de validação', showCloseButton: true, showConfirmButton: true, html: '<div style="font-size: 14px; text-align: left"><ul>' + errors + '</ul></div>' });
        }
        return valid;
    }

    const handleValidationRelatórioAnimaisDescartados = () => {
        var valid = true; var errors = '';
        if (!dataInicio) { valid = false; errors += '<li style="float:left;">Informe uma data de início!</li><br>'; }
        if (!dataFim) { valid = false; errors += '<li style="float:left;">Informe uma data de fim!</li><br>'; }
        if (!fazendaSelecionada) { valid = false; errors += '<li style="float:left;">Informe uma fazenda!</li><br>'; }
        if (!valid) {
            Swal.fire({ icon: 'warning', title: 'Erros de validação', showCloseButton: true, showConfirmButton: true, html: '<div style="font-size: 14px; text-align: left"><ul>' + errors + '</ul></div>' });
        }
        return valid;
    }

    const handleGerarRelatorioAnimaisAtivosPorPeriodo = () => {
        if (handleValidation()) {
            const { match: { params } } = props;
            let payload = { id: params.id, data_inicio: dataPosicao, fazendas_mais_de_um_ano: fazendasMaisDeUmAno, tipo_relatorio: "AA" };
            dispatch(relatorioAction.getRelatorio(payload, true));
        }
    }

    const handleGerarRelatorioAnimaisDescartadosPorPeriodo = () => {
        if (handleValidationRelatórioAnimaisDescartados()) {
            const { match: { params } } = props;
            let payload = { id: params.id, data_inicio: dataInicio, data_termino: dataFim, id_fazenda: fazendaSelecionada, tipo_relatorio: "AD" };
            dispatch(relatorioAction.getRelatorio(payload, true));
        }
    }

    const handleValidationRelatorioAnimaisSaida = () => {
        var valid = true; var errors = '';
        if (!dataFim) { valid = false; errors += '<li style="float:left;">Informe a data de saída!</li><br>'; }
        if (!fazendaSelecionada) { valid = false; errors += '<li style="float:left;">Informe uma fazenda!</li><br>'; }
        if (!valid) {
            Swal.fire({ icon: 'warning', title: 'Erros de validação', showCloseButton: true, showConfirmButton: true, html: '<div style="font-size: 14px; text-align: left"><ul>' + errors + '</ul></div>' });
        }
        return valid;
    }

    const handleGerarRelatorioAnimaisSaidaPorPeriodo = () => {
        if (handleValidationRelatorioAnimaisSaida()) {
            const { match: { params } } = props;
            let payload = { id: params ? params.id : 0, data_inicio: dataFim, data_termino: dataFim, id_fazenda: fazendaSelecionada, tipo_relatorio: "SA" };
            dispatch(relatorioAction.getRelatorio(payload, true));
        }
    }

    const handleValidationRelatorioInventario = () => {
        var valid = true; var errors = '';
        if (!fazendaSelecionada) { valid = false; errors += '<li style="float:left;">Informe uma fazenda!</li><br>'; }
        if (!valid) {
            Swal.fire({ icon: 'warning', title: 'Erros de validação', showCloseButton: true, showConfirmButton: true, html: '<div style="font-size: 14px; text-align: left"><ul>' + errors + '</ul></div>' });
        }
        return valid;
    }

    const handleGerarRelatorioInventario = () => {
        if (handleValidationRelatorioInventario()) {
            const { match: { params } } = props;
            let payload = { id: params ? params.id : 0, data_inicio: dataInicio, data_termino: dataFim, id_fazenda: fazendaSelecionada, tipo_relatorio: "IV", tipo_filtro_data: filtroDataInventario };
            dispatch(relatorioAction.getRelatorio(payload, true));
        }
    }

    // ---- ACASALAMENTOS handlers (igual ao fazendaEdit) ----
    const handleOpenModalImportAcasalamentos = () => { setSelectedImportFazenda(0); setSelectedImportFile(null); setOpenModalImportAcasalamentos(true); setOpenModalImportArquivo(false); };
    const handleCloseModalImportAcasalamentos = () => setOpenModalImportAcasalamentos(false);
    const handleSelectImportFazenda = (event) => {
        const id = event ? event.value : 0;
        setSelectedImportFazenda(id);
        // se selecionou fazenda válida, fecha modal de fazenda e abre modal de arquivo
        if (id) { setOpenModalImportAcasalamentos(false); setSelectedImportFile(null); setOpenModalImportArquivo(true); }
    };
    const handleSetImportFile = (e) => setSelectedImportFile(e.target.files && e.target.files[0] ? e.target.files[0] : null);
    const handleImportAcasalamentos = () => {
        if (!selectedImportFazenda) { Swal.fire({ icon: 'warning', title: 'Atenção', text: 'Selecione uma fazenda para importar acasalamentos.' }); return; }
        if (!selectedImportFile) { Swal.fire({ icon: 'warning', title: 'Atenção', text: 'Selecione um arquivo para importar.' }); return; }
        const fazendaLabel = (renderOptionsFazendas().find(o => o.value === selectedImportFazenda) || {}).label || selectedImportFazenda;
        Swal.fire({ title: 'Confirmar importação', html: `Deseja importar acasalamentos para a fazenda <b>${fazendaLabel}</b>?`, icon: 'question', showCancelButton: true, confirmButtonText: 'Sim, importar', cancelButtonText: 'Cancelar' }).then((result) => {
            if (result.isConfirmed) {
                var formData = new FormData(); formData.append('fazenda', selectedImportFazenda); formData.append('file', selectedImportFile);
                dispatch(fazendaAction.importAcasalamentosFazenda(formData, true));
                setOpenModalImportArquivo(false);
            }
        });
    }

    // ---- ANIMAIS DESCARTADOS handlers ----
    const handleOpenModalImportAnimaisDescartados = () => { setSelectedImportFazendaAnimais(0); setSelectedImportFileAnimais(null); setOpenModalImportAnimaisDescartados(true); setOpenModalImportAnimaisArquivo(false); };
    const handleCloseModalImportAnimaisDescartados = () => setOpenModalImportAnimaisDescartados(false);
    const handleSelectImportFazendaAnimais = (event) => {
        const id = event ? event.value : 0;
        setSelectedImportFazendaAnimais(id);
        // se selecionou fazenda válida, fecha modal de fazenda e abre modal de arquivo
        if (id) { setOpenModalImportAnimaisDescartados(false); setSelectedImportFileAnimais(null); setOpenModalImportAnimaisArquivo(true); }
    };
    const handleSetImportFileAnimais = (e) => setSelectedImportFileAnimais(e.target.files && e.target.files[0] ? e.target.files[0] : null);
    const handleImportAnimaisDescartados = () => {
        if (!selectedImportFazendaAnimais) { Swal.fire({ icon: 'warning', title: 'Atenção', text: 'Selecione uma fazenda para importar animais descartados.' }); return; }
        if (!selectedImportFileAnimais) { Swal.fire({ icon: 'warning', title: 'Atenção', text: 'Selecione um arquivo para importar.' }); return; }
        const fazendaLabel = (renderOptionsFazendas().find(o => o.value === selectedImportFazendaAnimais) || {}).label || selectedImportFazendaAnimais;
        Swal.fire({ title: 'Confirmar importação', html: `Deseja importar animais descartados para a fazenda <b>${fazendaLabel}</b>?`, icon: 'question', showCancelButton: true, confirmButtonText: 'Sim, importar', cancelButtonText: 'Cancelar' }).then((result) => {
            if (result.isConfirmed) {
                var formData = new FormData(); formData.append('fazenda', selectedImportFazendaAnimais); formData.append('file', selectedImportFileAnimais);
                dispatch(fazendaAction.importAnimaisDescartadosFazenda(formData, true));
                setOpenModalImportAnimaisArquivo(false);
            }
        });
    }

    // ---- CCS handlers ----
    const handleOpenModalImportCcs = () => { setSelectedImportFazendaCcs(0); setSelectedImportFileCcs(null); setOpenModalImportCcs(true); setOpenModalImportCcsArquivo(false); };
    const handleCloseModalImportCcs = () => setOpenModalImportCcs(false);
    const handleSelectImportFazendaCcs = (event) => { const id = event ? event.value : 0; setSelectedImportFazendaCcs(id); if (id) { setOpenModalImportCcs(false); setSelectedImportFileCcs(null); setOpenModalImportCcsArquivo(true); } };
    const handleSetImportFileCcs = (e) => setSelectedImportFileCcs(e.target.files && e.target.files[0] ? e.target.files[0] : null);
    const handleImportCcs = () => {
        if (!selectedImportFazendaCcs) { Swal.fire({ icon: 'warning', title: 'Atenção', text: 'Selecione uma fazenda para importar CCS.' }); return; }
        if (!selectedImportFileCcs) { Swal.fire({ icon: 'warning', title: 'Atenção', text: 'Selecione um arquivo para importar.' }); return; }
        const fazendaLabel = (renderOptionsFazendas().find(o => o.value === selectedImportFazendaCcs) || {}).label || selectedImportFazendaCcs;
        Swal.fire({ title: 'Confirmar importação', html: `Deseja importar CCS para a fazenda <b>${fazendaLabel}</b>?`, icon: 'question', showCancelButton: true, confirmButtonText: 'Sim, importar', cancelButtonText: 'Cancelar' }).then((result) => {
            if (result.isConfirmed) {
                var formData = new FormData(); formData.append('fazenda', selectedImportFazendaCcs); formData.append('file', selectedImportFileCcs);
                dispatch(fazendaAction.importCcsFazenda(formData, true));
                setOpenModalImportCcsArquivo(false);
            }
        });
    }

    // ---- CULTURA handlers ----
    const handleOpenModalImportCultura = () => { setSelectedImportFazendaCultura(0); setSelectedImportFileCultura(null); setOpenModalImportCultura(true); setOpenModalImportCulturaArquivo(false); };
    const handleCloseModalImportCultura = () => setOpenModalImportCultura(false);
    const handleSelectImportFazendaCultura = (event) => { const id = event ? event.value : 0; setSelectedImportFazendaCultura(id); if (id) { setOpenModalImportCultura(false); setSelectedImportFileCultura(null); setOpenModalImportCulturaArquivo(true); } };
    const handleSetImportFileCultura = (e) => setSelectedImportFileCultura(e.target.files && e.target.files[0] ? e.target.files[0] : null);
    const handleImportCultura = () => {
        if (!selectedImportFazendaCultura) { Swal.fire({ icon: 'warning', title: 'Atenção', text: 'Selecione uma fazenda para importar Cultura.' }); return; }
        if (!selectedImportFileCultura) { Swal.fire({ icon: 'warning', title: 'Atenção', text: 'Selecione um arquivo para importar.' }); return; }
        const fazendaLabel = (renderOptionsFazendas().find(o => o.value === selectedImportFazendaCultura) || {}).label || selectedImportFazendaCultura;
        Swal.fire({ title: 'Confirmar importação', html: `Deseja importar Cultura para a fazenda <b>${fazendaLabel}</b>?`, icon: 'question', showCancelButton: true, confirmButtonText: 'Sim, importar', cancelButtonText: 'Cancelar' }).then((result) => {
            if (result.isConfirmed) {
                var formData = new FormData(); formData.append('fazenda', selectedImportFazendaCultura); formData.append('file', selectedImportFileCultura);
                dispatch(fazendaAction.importCulturaFazenda(formData, true));
                setOpenModalImportCulturaArquivo(false);
            }
        });
    }

    // ---- INSEMINAÇÕES handlers ----
    const handleOpenModalImportInseminacoes = () => { setSelectedImportFazendaInseminacoes(0); setSelectedImportFileInseminacoes(null); setOpenModalImportInseminacoes(true); setOpenModalImportInseminacoesArquivo(false); };
    const handleCloseModalImportInseminacoes = () => setOpenModalImportInseminacoes(false);
    const handleSelectImportFazendaInseminacoes = (event) => { const id = event ? event.value : 0; setSelectedImportFazendaInseminacoes(id); if (id) { setOpenModalImportInseminacoes(false); setSelectedImportFileInseminacoes(null); setOpenModalImportInseminacoesArquivo(true); } };
    const handleSetImportFileInseminacoes = (e) => setSelectedImportFileInseminacoes(e.target.files && e.target.files[0] ? e.target.files[0] : null);
    const handleImportInseminacoes = () => {
        if (!selectedImportFazendaInseminacoes) { Swal.fire({ icon: 'warning', title: 'Atenção', text: 'Selecione uma fazenda para importar inseminações.' }); return; }
        if (!selectedImportFileInseminacoes) { Swal.fire({ icon: 'warning', title: 'Atenção', text: 'Selecione um arquivo para importar.' }); return; }
        const fazendaLabel = (renderOptionsFazendas().find(o => o.value === selectedImportFazendaInseminacoes) || {}).label || selectedImportFazendaInseminacoes;
        Swal.fire({ title: 'Confirmar importação', html: `Deseja importar inseminações para a fazenda <b>${fazendaLabel}</b>?`, icon: 'question', showCancelButton: true, confirmButtonText: 'Sim, importar', cancelButtonText: 'Cancelar' }).then((result) => {
            if (result.isConfirmed) {
                var formData = new FormData(); formData.append('fazenda', selectedImportFazendaInseminacoes); formData.append('file', selectedImportFileInseminacoes);
                dispatch(fazendaAction.importInseminacoesFazenda(formData, true));
                setOpenModalImportInseminacoesArquivo(false);
            }
        });
    }

    // ---- PARTOS handlers ----
    const handleOpenModalImportPartos = () => { setSelectedImportFazendaPartos(0); setSelectedImportFilePartos(null); setOpenModalImportPartos(true); setOpenModalImportPartosArquivo(false); };
    const handleCloseModalImportPartos = () => setOpenModalImportPartos(false);
    const handleSelectImportFazendaPartos = (event) => { const id = event ? event.value : 0; setSelectedImportFazendaPartos(id); if (id) { setOpenModalImportPartos(false); setSelectedImportFilePartos(null); setOpenModalImportPartosArquivo(true); } };
    const handleSetImportFilePartos = (e) => setSelectedImportFilePartos(e.target.files && e.target.files[0] ? e.target.files[0] : null);
    const handleImportPartos = () => {
        if (!selectedImportFazendaPartos) { Swal.fire({ icon: 'warning', title: 'Atenção', text: 'Selecione uma fazenda para importar partos.' }); return; }
        if (!selectedImportFilePartos) { Swal.fire({ icon: 'warning', title: 'Atenção', text: 'Selecione um arquivo para importar.' }); return; }
        const fazendaLabel = (renderOptionsFazendas().find(o => o.value === selectedImportFazendaPartos) || {}).label || selectedImportFazendaPartos;
        Swal.fire({ title: 'Confirmar importação', html: `Deseja importar partos para a fazenda <b>${fazendaLabel}</b>?`, icon: 'question', showCancelButton: true, confirmButtonText: 'Sim, importar', cancelButtonText: 'Cancelar' }).then((result) => {
            if (result.isConfirmed) {
                var formData = new FormData(); formData.append('fazenda', selectedImportFazendaPartos); formData.append('file', selectedImportFilePartos);
                dispatch(fazendaAction.importPartosFazenda(formData, true));
                setOpenModalImportPartosArquivo(false);
            }
        });
    }

    // ---- PESAGENS handlers ----
    const handleOpenModalImportPesagens = () => { setSelectedImportFazendaPesagens(0); setSelectedImportFilePesagens(null); setOpenModalImportPesagens(true); setOpenModalImportPesagensArquivo(false); };
    const handleCloseModalImportPesagens = () => setOpenModalImportPesagens(false);
    const handleSelectImportFazendaPesagens = (event) => { const id = event ? event.value : 0; setSelectedImportFazendaPesagens(id); if (id) { setOpenModalImportPesagens(false); setSelectedImportFilePesagens(null); setOpenModalImportPesagensArquivo(true); } };
    const handleSetImportFilePesagens = (e) => setSelectedImportFilePesagens(e.target.files && e.target.files[0] ? e.target.files[0] : null);
    const handleImportPesagens = () => {
        if (!selectedImportFazendaPesagens) { Swal.fire({ icon: 'warning', title: 'Atenção', text: 'Selecione uma fazenda para importar pesagens.' }); return; }
        if (!selectedImportFilePesagens) { Swal.fire({ icon: 'warning', title: 'Atenção', text: 'Selecione um arquivo para importar.' }); return; }
        const fazendaLabel = (renderOptionsFazendas().find(o => o.value === selectedImportFazendaPesagens) || {}).label || selectedImportFazendaPesagens;
        Swal.fire({ title: 'Confirmar importação', html: `Deseja importar pesagens para a fazenda <b>${fazendaLabel}</b>?`, icon: 'question', showCancelButton: true, confirmButtonText: 'Sim, importar', cancelButtonText: 'Cancelar' }).then((result) => {
            if (result.isConfirmed) {
                var formData = new FormData(); formData.append('fazenda', selectedImportFazendaPesagens); formData.append('file', selectedImportFilePesagens);
                dispatch(fazendaAction.importPesagensFazenda(formData, true));
                setOpenModalImportPesagensArquivo(false);
            }
        });
    }

    // ---- PRODUÇÕES handlers ----
    const handleOpenModalImportProducao = () => { setSelectedImportFazendaProducao(0); setSelectedImportFileProducao(null); setOpenModalImportProducao(true); setOpenModalImportProducaoArquivo(false); };
    const handleCloseModalImportProducao = () => setOpenModalImportProducao(false);
    const handleSelectImportFazendaProducao = (event) => { const id = event ? event.value : 0; setSelectedImportFazendaProducao(id); if (id) { setOpenModalImportProducao(false); setSelectedImportFileProducao(null); setOpenModalImportProducaoArquivo(true); } };
    const handleSetImportFileProducao = (e) => setSelectedImportFileProducao(e.target.files && e.target.files[0] ? e.target.files[0] : null);
    const handleImportProducao = () => {
        if (!selectedImportFazendaProducao) { Swal.fire({ icon: 'warning', title: 'Atenção', text: 'Selecione uma fazenda para importar produções.' }); return; }
        if (!selectedImportFileProducao) { Swal.fire({ icon: 'warning', title: 'Atenção', text: 'Selecione um arquivo para importar.' }); return; }
        const fazendaLabel = (renderOptionsFazendas().find(o => o.value === selectedImportFazendaProducao) || {}).label || selectedImportFazendaProducao;
        Swal.fire({ title: 'Confirmar importação', html: `Deseja importar produções para a fazenda <b>${fazendaLabel}</b>?`, icon: 'question', showCancelButton: true, confirmButtonText: 'Sim, importar', cancelButtonText: 'Cancelar' }).then((result) => {
            if (result.isConfirmed) {
                var formData = new FormData(); formData.append('fazenda', selectedImportFazendaProducao); formData.append('file', selectedImportFileProducao);
                dispatch(fazendaAction.importProducaoFazenda(formData, true));
                setOpenModalImportProducaoArquivo(false);
            }
        });
    }

    // ---- SECAGENS handlers ----
    const handleOpenModalImportSecagens = () => { setSelectedImportFazendaSecagens(0); setSelectedImportFileSecagens(null); setOpenModalImportSecagens(true); setOpenModalImportSecagensArquivo(false); };
    const handleCloseModalImportSecagens = () => setOpenModalImportSecagens(false);
    const handleSelectImportFazendaSecagens = (event) => { const id = event ? event.value : 0; setSelectedImportFazendaSecagens(id); if (id) { setOpenModalImportSecagens(false); setSelectedImportFileSecagens(null); setOpenModalImportSecagensArquivo(true); } };
    const handleSetImportFileSecagens = (e) => setSelectedImportFileSecagens(e.target.files && e.target.files[0] ? e.target.files[0] : null);
    const handleImportSecagens = () => {
        if (!selectedImportFazendaSecagens) { Swal.fire({ icon: 'warning', title: 'Atenção', text: 'Selecione uma fazenda para importar secagens.' }); return; }
        if (!selectedImportFileSecagens) { Swal.fire({ icon: 'warning', title: 'Atenção', text: 'Selecione um arquivo para importar.' }); return; }
        const fazendaLabel = (renderOptionsFazendas().find(o => o.value === selectedImportFazendaSecagens) || {}).label || selectedImportFazendaSecagens;
        Swal.fire({ title: 'Confirmar importação', html: `Deseja importar secagens para a fazenda <b>${fazendaLabel}</b>?`, icon: 'question', showCancelButton: true, confirmButtonText: 'Sim, importar', cancelButtonText: 'Cancelar' }).then((result) => {
            if (result.isConfirmed) {
                var formData = new FormData(); formData.append('fazenda', selectedImportFazendaSecagens); formData.append('file', selectedImportFileSecagens);
                dispatch(fazendaAction.importSecagensFazenda(formData, true));
                setOpenModalImportSecagensArquivo(false);
            }
        });
    }

    /*const renderOptionsFazendas = () => {
        return props.fazenda.fazenda.map((p, i) => ({ value: p.id, label: p.nome, key: i }));
    };*/

    const renderOptionsFazendas = () => {
        return props.fazenda?.fazenda?.map((p, i) => ({
            value: p.id,
            label: p.nome,
            key: i
        })) || [];
    };


    const handleSelectChange = (prop) => (event) => {
        if (prop === 'id_fazenda') setFazendaSelecionada(event.value);
    };

    return (
        <div>
            <Navbar color="light" light expand="md">
                <NavbarBrand href="/home">
                    <img src={require('../imgs/banner_gestor_rp_horizontal.png')} width="210" height="auto" alt="logo" className="logo p-0 m-0" />
                </NavbarBrand>
                <NavbarToggler onClick={toggle} />
                <Collapse isOpen={isOpen} navbar>
                    <Nav>
                        {!authActions.isPrefeitura() &&
                            <>
                                <UncontrolledDropdown nav inNavbar>
                                    <DropdownToggle nav caret>Importações</DropdownToggle>
                                    <DropdownMenu>
                                        {(authActions.isGestor() || authActions.isAdministrador()) &&
                                            <>
                                                <DropdownItem><NavLink href="#" onClick={(e) => { e.preventDefault(); handleOpenModalImportAcasalamentos(); }}>Acasalamentos</NavLink></DropdownItem>
                                                <DropdownItem><NavLink href="#" onClick={(e) => { e.preventDefault(); handleOpenModalImportAnimaisDescartados(); }}>Animais descartados</NavLink></DropdownItem>
                                                <DropdownItem><NavLink href="#" onClick={(e) => { e.preventDefault(); handleOpenModalImportCcs(); }}>CCS</NavLink></DropdownItem>
                                                <DropdownItem><NavLink href="#" onClick={(e) => { e.preventDefault(); handleOpenModalImportCultura(); }}>Cultura</NavLink></DropdownItem>
                                                <DropdownItem><NavLink href="#" onClick={(e) => { e.preventDefault(); handleOpenModalImportInseminacoes(); }}>Inseminações</NavLink></DropdownItem>
                                                <DropdownItem><NavLink href="#" onClick={(e) => { e.preventDefault(); handleOpenModalImportPartos(); }}>Partos</NavLink></DropdownItem>
                                                <DropdownItem><NavLink href="#" onClick={(e) => { e.preventDefault(); handleOpenModalImportPesagens(); }}>Pesagens</NavLink></DropdownItem>
                                                <DropdownItem><NavLink href="#" onClick={(e) => { e.preventDefault(); handleOpenModalImportProducao(); }}>Produções</NavLink></DropdownItem>
                                                <DropdownItem><NavLink href="#" onClick={(e) => { e.preventDefault(); handleOpenModalImportSecagens(); }}>Secagens</NavLink></DropdownItem>
                                            </>
                                        }
                                    </DropdownMenu>
                                </UncontrolledDropdown>

                                <UncontrolledDropdown nav inNavbar>
                                    <DropdownToggle nav caret>Cadastros</DropdownToggle>
                                    <DropdownMenu>
                                        {authActions.isGestor() && <>
                                            <DropdownItem><NavLink href="/banners">Banners</NavLink></DropdownItem>
                                            {!authActions.isAdministrador() && <DropdownItem><NavLink href="/convenios">Convênios</NavLink></DropdownItem>}
                                            <DropdownItem><NavLink href="/empresas">Empresas</NavLink></DropdownItem>
                                            <DropdownItem><NavLink href="/prefeituras">Prefeituras</NavLink></DropdownItem>
                                            <DropdownItem><NavLink href="/versoesSistemas">Versões do Sistema</NavLink></DropdownItem>
                                            <DropdownItem><NavLink href="/termosUsos">Termos de Uso</NavLink></DropdownItem>
                                        </>}
                                        <DropdownItem><NavLink href="/partos">Partos</NavLink></DropdownItem>
                                        <DropdownItem><NavLink href="/tanques">Tanques</NavLink></DropdownItem>
                                        {authActions.isGestor() && <DropdownItem><NavLink href="/usuarios">Usuários</NavLink></DropdownItem>}
                                    </DropdownMenu>
                                </UncontrolledDropdown>

                                <UncontrolledDropdown nav inNavbar>
                                    <DropdownToggle nav caret>Listagens</DropdownToggle>
                                    <DropdownMenu>
                                        <DropdownItem><NavLink href="/animais">Animais</NavLink></DropdownItem>
                                        {authActions.isGestor() && <>
                                            <DropdownItem><NavLink href="/empresas">Empresas</NavLink></DropdownItem>
                                            <DropdownItem><NavLink href="/fazendas">Fazendas e Importação de Dados</NavLink></DropdownItem>
                                            <DropdownItem><NavLink href="/prefeituras">Prefeituras</NavLink></DropdownItem>
                                        </>}
                                        {authActions.isGestor() && <DropdownItem><NavLink href="/execucoes">Rotinas</NavLink></DropdownItem>}
                                        {authActions.isGestor() && <DropdownItem><NavLink href="/usuarios">Usuários</NavLink></DropdownItem>}
                                    </DropdownMenu>
                                </UncontrolledDropdown>

                                {authActions.isGestor() &&
                                    <UncontrolledDropdown nav inNavbar>
                                        <DropdownToggle nav caret>Dashboards</DropdownToggle>
                                        <DropdownMenu>
                                            <DropdownItem><NavLink href="/dashboardTanques">Dashboard de Tanques</NavLink></DropdownItem>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                }

                                <UncontrolledDropdown nav inNavbar>
                                    <DropdownToggle nav caret>Relatórios</DropdownToggle>
                                    <DropdownMenu>
                                        <NavItem><NavLink href="/visita">Gerar Relatórios</NavLink></NavItem>
                                        <NavItem><NavLink href="/visitas">Lista de Relatórios</NavLink></NavItem>
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </>
                        }
                        {((authActions.isGestor()) || authActions.isPrefeitura() || authActions.isInseminador() || authActions.isAdministrador()) &&
                            <UncontrolledDropdown nav inNavbar>
                                <DropdownToggle nav caret>Relatórios Internos</DropdownToggle>
                                <DropdownMenu>
                                    {authActions.isGestor() && <>
                                        <DropdownItem><NavLink href="#" onClick={handleOpenModalAnimaisAtivos}>Animais ativos por período</NavLink></DropdownItem>
                                        <DropdownItem><NavLink href="#" onClick={handleOpenModalAnimaisDescartados}>Animais descartados por período</NavLink></DropdownItem>
                                        <DropdownItem><NavLink href="#" onClick={handleOpenModalSelectFazenda}>Animais por fazenda</NavLink></DropdownItem>
                                        <DropdownItem><NavLink href="#" onClick={handleOpenModalFichaAnimal}>Ficha do Animal</NavLink></DropdownItem>
                                        <DropdownItem><NavLink href="#" onClick={handleOpenModalNascimentos}>Comunicação de Nascimentos</NavLink></DropdownItem>
                                        <DropdownItem><NavLink href="#" onClick={handleGerarRelatorio}>Fazendas por data de sincronismo</NavLink></DropdownItem>
                                        <DropdownItem><NavLink href="#" onClick={handleOpenModalSelectEmpresa}>Fazendas com empresas e animais ativos</NavLink></DropdownItem>
                                    </>}
                                    {(authActions.isGestor() || authActions.isPrefeitura() || authActions.isAdministrador()) && <>
                                        <DropdownItem><NavLink onClick={handleOpenModalAnimaisInseminacoes}>Inseminações</NavLink></DropdownItem>
                                        {!authActions.isAdministrador() && <DropdownItem><NavLink href="/relatorioFiltro">Inseminações - Prefeituras</NavLink></DropdownItem>}
                                    </>}
                                    {authActions.isGestor() && <>
                                        <DropdownItem><NavLink onClick={handleOpenModalAnimaisPartos}>Partos</NavLink></DropdownItem>
                                        <DropdownItem><NavLink href="#" onClick={handleOpenModalProducoes}>Produções por período</NavLink></DropdownItem>
                                    </>}
                                    {(authActions.isGestor() || authActions.isAdministrador()) && (
                                        <>
                                            <DropdownItem>
                                                <NavLink href="#" onClick={handleOpenModalProducoesLote}>
                                                    Produções de Lote por período
                                                </NavLink>
                                            </DropdownItem>
                                            <DropdownItem>
                                                <NavLink href="#" onClick={handleOpenModalAnimaisSaida}>
                                                    Relatório de Saída dos Animais
                                                </NavLink>
                                            </DropdownItem>
                                            <DropdownItem>
                                                <NavLink href="#" onClick={handleOpenModalInventario}>
                                                    Relatório de Inventário
                                                </NavLink>
                                            </DropdownItem>
                                            <DropdownItem><NavLink href="#" onClick={handleOpenModalRelatorioVisitas}>Fazendas sem Visita</NavLink></DropdownItem>
                                        </>
                                    )}
                                    {authActions.isGestor() && <>
                                        <DropdownItem><NavLink href="#" onClick={handleOpenModalTanques}>Tanques por período</NavLink></DropdownItem>
                                        <DropdownItem><NavLink href="/relatorioLog">Logs</NavLink></DropdownItem>
                                    </>}
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        }
                        {authActions.isGestor() && <NavItem><NavLink href="/certificadosAVencer">Certificados a Vencer</NavLink></NavItem>}
                    </Nav>

                    <Nav className="ml-auto">
                        <NavItem>
                            <NavLink style={{ cursor: 'pointer' }} onClick={() => dispatch(authActions.logout(true, navigate))}>
                                <small>({JSON.parse(localStorage.getItem('user'))["nome"]})</small> Sair
                            </NavLink>
                        </NavItem>
                    </Nav>
                </Collapse>

                <ModalAnimaisFazenda props={props} openModalSelectFazenda={openModalSelectFazenda} handleCloseModalSelectFazenda={handleCloseModalSelectFazenda} />
                <ModalFichaAnimal props={props} openModalFichaAnimal={openModalFichaAnimal} handleCloseModalFichaAnimal={handleCloseModalFichaAnimal} />

                <ModalSelectEmpresa props={props} openModalSelectEmpresa={openModalSelectEmpresa} handleCloseModalSelectEmpresa={handleCloseModalSelectEmpresa} />
                <Modal isOpen={openModalAnimaisAtivos} onClose={handleCloseModalAnimaisAtivos} aria-labelledby="form-dialog-title">
                    <ModalHeader id="form-dialog-title">Gerar relatório de animais ativos por período</ModalHeader>
                    <ModalBody>
                        <FormGroup className="mb-0">
                            <Row className="mt-1">
                                <Col>
                                    <Label className="left" for="data_posicao">Data de posição: *</Label>
                                    <Input
                                        id="data_posicao"
                                        label="Data de posição *"
                                        className="form-control"
                                        type="date"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        value={dataPosicao}
                                        onChange={(e) => setDataPosicao(e.target.value)}
                                    />
                                </Col>
                            </Row>
                            <Row className="mt-2">
                                <Col style={{ display: 'flex', flexDirection: 'row', alignContent: 'bottom', alignItems: 'bottom' }}>
                                    <div>
                                        <Label className="left" for="fazendas_mais_um_ano">Listar somente fazendas com mais de 1 ano:</Label>
                                    </div>
                                    <div>
                                        <Input
                                            id="fazendas_mais_um_ano"
                                            label="Listar somente fazendas com mais de 1 ano"
                                            type="checkbox"
                                            checked={fazendasMaisDeUmAno || false}
                                            onChange={(e) => setFazendasMaisDeUmAno(e.target.checked)}
                                            style={{ marginLeft: 12 }}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={handleCloseModalAnimaisAtivos} color="secondary">Cancelar</Button>
                        <Button onClick={handleGerarRelatorioAnimaisAtivosPorPeriodo} color="primary">Gerar relatório</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={openModalAnimaisDescartados} onClose={handleCloseModalAnimaisDescartados} aria-labelledby="form-dialog-title">
                    <ModalHeader id="form-dialog-title">Gerar relatório de animais descartados por período</ModalHeader>
                    <ModalBody>
                        <FormGroup className="mb-0">
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Label className="left" for="selecionarFazenda">Selecione uma fazenda: *</Label>
                                        {openModalAnimaisDescartados &&
                                            <Select
                                                classNamePrefix="select"
                                                value={renderOptionsFazendas().filter(option => option.value === (fazendaSelecionada || 0))}
                                                onChange={handleSelectChange('id_fazenda')}
                                                isSearchable
                                                placeholder="Selecione..."
                                                id="id_fazenda"
                                                name="id_fazenda"
                                                options={renderOptionsFazendas()}
                                            />
                                        }
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row className="mt-1">
                                <Col>
                                    <Label className="left" for="data_inicio">Data de in&iacute;cio: *</Label>
                                    <Input
                                        id="data_inicio"
                                        label="Data de início *"
                                        className="form-control"
                                        type="date"
                                        InputLabelProps={{ shrink: true }}
                                        value={dataInicio}
                                        onChange={(e) => setDataInicio(e.target.value)}
                                    />
                                </Col>
                                <Col>
                                    <Label className="left" for="data_fim">Data de fim: *</Label>
                                    <Input
                                        id="data_fim"
                                        label="Data de fim *"
                                        className="form-control"
                                        type="date"
                                        InputLabelProps={{ shrink: true }}
                                        value={dataFim}
                                        onChange={(e) => setDataFim(e.target.value)}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={handleCloseModalAnimaisDescartados} color="secondary">Cancelar</Button>
                        <Button onClick={handleGerarRelatorioAnimaisDescartadosPorPeriodo} color="primary">Gerar relatório</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={openModalAnimaisSaida} onClose={handleCloseModalAnimaisSaida} aria-labelledby="form-dialog-title">
                    <ModalHeader id="form-dialog-title">Gerar relatório de saída dos animais</ModalHeader>
                    <ModalBody>
                        <FormGroup className="mb-0">
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Label className="left" for="selecionarFazendaSaida">Selecione uma fazenda: *</Label>
                                        {openModalAnimaisSaida &&
                                            <Select
                                                classNamePrefix="select"
                                                value={renderOptionsFazendas().filter(option => option.value === (fazendaSelecionada || 0))}
                                                onChange={handleSelectChange('id_fazenda')}
                                                isSearchable
                                                placeholder="Selecione..."
                                                id="id_fazenda_saida"
                                                name="id_fazenda_saida"
                                                options={renderOptionsFazendas()}
                                            />
                                        }
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row className="mt-1">
                                <Col>
                                    <Label className="left" for="data_fim_saida">Data de Sa&iacute;da: *</Label>
                                    <Input
                                        id="data_fim_saida"
                                        label="Data de Saída *"
                                        className="form-control"
                                        type="date"
                                        InputLabelProps={{ shrink: true }}
                                        value={dataFim}
                                        onChange={(e) => setDataFim(e.target.value)}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={handleCloseModalAnimaisSaida} color="secondary">Cancelar</Button>
                        <Button onClick={handleGerarRelatorioAnimaisSaidaPorPeriodo} color="primary">Gerar relatório</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={openModalInventario} onClose={handleCloseModalInventario} aria-labelledby="form-dialog-title">
                    <ModalHeader id="form-dialog-title">Gerar relatório de inventário</ModalHeader>
                    <ModalBody>
                        <FormGroup className="mb-0">
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Label className="left" for="selecionarFazendaInventario">Selecione uma fazenda: *</Label>
                                        {openModalInventario &&
                                            <Select
                                                classNamePrefix="select"
                                                value={renderOptionsFazendas().filter(option => option.value === (fazendaSelecionada || 0))}
                                                onChange={handleSelectChange('id_fazenda')}
                                                isSearchable
                                                placeholder="Selecione..."
                                                id="id_fazenda_inventario"
                                                name="id_fazenda_inventario"
                                                options={renderOptionsFazendas()}
                                            />
                                        }
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row className="mt-1">
                                <Col>
                                    <FormGroup>
                                        <Label className="left">Tipo de Filtro de Data:</Label>
                                        <div style={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>
                                            <FormGroup check>
                                                <Label check>
                                                    <Input 
                                                        type="radio" 
                                                        name="tipo_filtro_data_inventario" 
                                                        value="entrada_saida" 
                                                        checked={filtroDataInventario === 'entrada_saida'} 
                                                        onChange={(e) => setFiltroDataInventario(e.target.value)} 
                                                    />{' '}
                                                    Data Entrada / Saída
                                                </Label>
                                            </FormGroup>
                                            <FormGroup check>
                                                <Label check>
                                                    <Input 
                                                        type="radio" 
                                                        name="tipo_filtro_data_inventario" 
                                                        value="nascimento_descarte_exclusao" 
                                                        checked={filtroDataInventario === 'nascimento_descarte_exclusao'} 
                                                        onChange={(e) => setFiltroDataInventario(e.target.value)} 
                                                    />{' '}
                                                    Data Nasc. / Desc. / Exclusão
                                                </Label>
                                            </FormGroup>
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row className="mt-1">
                                <Col>
                                    <Label className="left" for="data_inicio_inventario">Data de in&iacute;cio:</Label>
                                    <Input
                                        id="data_inicio_inventario"
                                        label="Data de início"
                                        className="form-control"
                                        type="date"
                                        InputLabelProps={{ shrink: true }}
                                        value={dataInicio}
                                        onChange={(e) => setDataInicio(e.target.value)}
                                    />
                                </Col>
                                <Col>
                                    <Label className="left" for="data_fim_inventario">Data de fim:</Label>
                                    <Input
                                        id="data_fim_inventario"
                                        label="Data de fim"
                                        className="form-control"
                                        type="date"
                                        InputLabelProps={{ shrink: true }}
                                        value={dataFim}
                                        onChange={(e) => setDataFim(e.target.value)}
                                    />
                                </Col>
                            </Row>
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={handleCloseModalInventario} color="secondary">Cancelar</Button>
                        <Button onClick={handleGerarRelatorioInventario} color="primary">Gerar relatório</Button>
                    </ModalFooter>
                </Modal>

                {/* Modal ACASALAMENTOS: selecionar fazenda */}
                <Modal isOpen={openModalImportAcasalamentos} onClose={handleCloseModalImportAcasalamentos} aria-labelledby="modal-import-acasalamentos">
                    <ModalHeader id="modal-import-acasalamentos">Importar Acasalamentos - Selecione a Fazenda</ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label className="left" for="select_import_fazenda">Selecione a Fazenda</Label>
                            {openModalImportAcasalamentos &&
                                <Select
                                    classNamePrefix="select"
                                    value={renderOptionsFazendas().filter(option => option.value === (selectedImportFazenda || 0))}
                                    onChange={handleSelectImportFazenda}
                                    isSearchable
                                    placeholder="Selecione..."
                                    id="select_import_fazenda"
                                    name="select_import_fazenda"
                                    options={renderOptionsFazendas()}
                                />
                            }
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={handleCloseModalImportAcasalamentos} color="secondary">Cancelar</Button>
                    </ModalFooter>
                </Modal>

                {/* Modal ACASALAMENTOS: selecionar arquivo */}
                <Modal isOpen={openModalImportArquivo} onClose={() => setOpenModalImportArquivo(false)} aria-labelledby="modal-import-arquivo">
                    <ModalHeader id="modal-import-arquivo">Importar Acasalamentos - Selecionar Arquivo</ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label className="left" for="arquivo_import_acasalamentos">Fazenda</Label>
                            <Input
                                id="arquivo_import_fazenda_nome"
                                label="Fazenda"
                                className="form-control"
                                value={(renderOptionsFazendas().find(o => o.value === selectedImportFazenda) || {}).label || ''}
                                readOnly
                            />
                        </FormGroup>

                        <FormGroup className="mt-3">
                            <p>
                                <span>Arquivo em formato Excel (.xls, .xlsx, .csv) contendo os acasalamentos.</span><br />
                                <span>Arquivo de modelo: <a href="./modelo_importacao_acasalamentos.xlsx" target="_blank" download>Modelo de Importação de Acasalamentos</a></span>
                            </p>
                            <Label className="left" for="arquivo_import_acasalamentos">Arquivo</Label>
                            <Input
                                id="arquivo_import_acasalamentos"
                                label="Arquivo"
                                type="file"
                                onChange={handleSetImportFile}
                            />
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={() => { setOpenModalImportArquivo(false); setSelectedImportFile(null); }} color="secondary">Cancelar</Button>
                        <Button onClick={handleImportAcasalamentos} color="primary">Importar</Button>
                    </ModalFooter>
                </Modal>

                {/* Modal ANIMAIS DESCARTADOS: selecionar fazenda */}
                <Modal isOpen={openModalImportAnimaisDescartados} onClose={handleCloseModalImportAnimaisDescartados} aria-labelledby="modal-import-animais-descartados">
                    <ModalHeader id="modal-import-animais-descartados">Importar Animais Descartados - Selecione a Fazenda</ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label className="left" for="select_import_fazenda_animais">Selecione a Fazenda</Label>
                            {openModalImportAnimaisDescartados &&
                                <Select
                                    classNamePrefix="select"
                                    value={renderOptionsFazendas().filter(option => option.value === (selectedImportFazendaAnimais || 0))}
                                    onChange={handleSelectImportFazendaAnimais}
                                    isSearchable
                                    placeholder="Selecione..."
                                    id="select_import_fazenda_animais"
                                    name="select_import_fazenda_animais"
                                    options={renderOptionsFazendas()}
                                />
                            }
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={handleCloseModalImportAnimaisDescartados} color="secondary">Cancelar</Button>
                    </ModalFooter>
                </Modal>

                {/* Modal ANIMAIS DESCARTADOS: selecionar arquivo */}
                <Modal isOpen={openModalImportAnimaisArquivo} onClose={() => setOpenModalImportAnimaisArquivo(false)} aria-labelledby="modal-import-animais-arquivo">
                    <ModalHeader id="modal-import-animais-arquivo">Importar Animais Descartados - Selecionar Arquivo</ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label className="left" for="arquivo_import_animais_fazenda">Fazenda</Label>
                            <Input
                                id="arquivo_import_animais_fazenda"
                                label="Fazenda"
                                className="form-control"
                                value={(renderOptionsFazendas().find(o => o.value === selectedImportFazendaAnimais) || {}).label || ''}
                                readOnly
                            />
                        </FormGroup>

                        <FormGroup className="mt-3">
                            <p>
                                <span>Arquivo em formato Excel (.xls, .xlsx, .csv) contendo os animais descartados.</span><br />
                                <span>Arquivo de modelo: <a href="./modelo_importacao_animais_descartados.xlsx" target="_blank" download>Modelo de Importação de Animais Descartados</a></span>
                            </p>
                            <Label className="left" for="arquivo_import_animais">Arquivo</Label>
                            <Input
                                id="arquivo_import_animais"
                                label="Arquivo"
                                type="file"
                                onChange={handleSetImportFileAnimais}
                            />
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={() => { setOpenModalImportAnimaisArquivo(false); setSelectedImportFileAnimais(null); }} color="secondary">Cancelar</Button>
                        <Button onClick={handleImportAnimaisDescartados} color="primary">Importar</Button>
                    </ModalFooter>
                </Modal>

                {/* Modal CCS: selecionar fazenda */}
                <Modal isOpen={openModalImportCcs} onClose={handleCloseModalImportCcs} aria-labelledby="modal-import-ccs">
                    <ModalHeader id="modal-import-ccs">Importar CCS - Selecione a Fazenda</ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label className="left" for="select_import_fazenda_ccs">Selecione a Fazenda</Label>
                            {openModalImportCcs &&
                                <Select
                                    classNamePrefix="select"
                                    value={renderOptionsFazendas().filter(option => option.value === (selectedImportFazendaCcs || 0))}
                                    onChange={handleSelectImportFazendaCcs}
                                    isSearchable
                                    placeholder="Selecione..."
                                    id="select_import_fazenda_ccs"
                                    name="select_import_fazenda_ccs"
                                    options={renderOptionsFazendas()}
                                />
                            }
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={handleCloseModalImportCcs} color="secondary">Cancelar</Button>
                    </ModalFooter>
                </Modal>

                {/* Modal CCS: selecionar arquivo */}
                <Modal isOpen={openModalImportCcsArquivo} onClose={() => setOpenModalImportCcsArquivo(false)} aria-labelledby="modal-import-ccs-arquivo">
                    <ModalHeader id="modal-import-ccs-arquivo">Importar CCS - Selecionar Arquivo</ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label className="left" for="arquivo_import_ccs_fazenda">Fazenda</Label>
                            <Input
                                id="arquivo_import_ccs_fazenda"
                                label="Fazenda"
                                className="form-control"
                                value={(renderOptionsFazendas().find(o => o.value === selectedImportFazendaCcs) || {}).label || ''}
                                readOnly
                            />
                        </FormGroup>

                        <FormGroup className="mt-3">
                            <p>
                                <span>Arquivo em formato Excel (.xls, .xlsx, .csv) contendo os CCS.</span><br />
                                <span>Arquivo de modelo: <a href="./modelo_importacao_ccs.xlsx" target="_blank" download>Modelo de Importação de CCS</a></span>
                            </p>
                            <Label className="left" for="arquivo_import_ccs">Arquivo</Label>
                            <Input
                                id="arquivo_import_ccs"
                                label="Arquivo"
                                type="file"
                                onChange={handleSetImportFileCcs}
                            />
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={() => { setOpenModalImportCcsArquivo(false); setSelectedImportFileCcs(null); }} color="secondary">Cancelar</Button>
                        <Button onClick={handleImportCcs} color="primary">Importar</Button>
                    </ModalFooter>
                </Modal>

                {/* Modal CULTURA: selecionar fazenda */}
                <Modal isOpen={openModalImportCultura} onClose={handleCloseModalImportCultura} aria-labelledby="modal-import-cultura">
                    <ModalHeader id="modal-import-cultura">Importar Cultura - Selecione a Fazenda</ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label className="left" for="select_import_fazenda_cultura">Selecione a Fazenda</Label>
                            {openModalImportCultura &&
                                <Select
                                    classNamePrefix="select"
                                    value={renderOptionsFazendas().filter(option => option.value === (selectedImportFazendaCultura || 0))}
                                    onChange={handleSelectImportFazendaCultura}
                                    isSearchable
                                    placeholder="Selecione..."
                                    id="select_import_fazenda_cultura"
                                    name="select_import_fazenda_cultura"
                                    options={renderOptionsFazendas()}
                                />
                            }
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={handleCloseModalImportCultura} color="secondary">Cancelar</Button>
                    </ModalFooter>
                </Modal>

                {/* Modal CULTURA: selecionar arquivo */}
                <Modal isOpen={openModalImportCulturaArquivo} onClose={() => setOpenModalImportCulturaArquivo(false)} aria-labelledby="modal-import-cultura-arquivo">
                    <ModalHeader id="modal-import-cultura-arquivo">Importar Cultura - Selecionar Arquivo</ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label className="left" for="arquivo_import_cultura_fazenda">Fazenda</Label>
                            <Input
                                id="arquivo_import_cultura_fazenda"
                                label="Fazenda"
                                className="form-control"
                                value={(renderOptionsFazendas().find(o => o.value === selectedImportFazendaCultura) || {}).label || ''}
                                readOnly
                            />
                        </FormGroup>

                        <FormGroup className="mt-3">
                            <p>
                                <span>Arquivo em formato Excel (.xls, .xlsx, .csv) contendo a Cultura.</span><br />
                                <span>Arquivo de modelo: <a href="./modelo_importacao_cultura.xlsx" target="_blank" download>Modelo de Importação de Cultura</a></span>
                            </p>
                            <Label className="left" for="arquivo_import_cultura">Arquivo</Label>
                            <Input
                                id="arquivo_import_cultura"
                                label="Arquivo"
                                type="file"
                                onChange={handleSetImportFileCultura}
                            />
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={() => { setOpenModalImportCulturaArquivo(false); setSelectedImportFileCultura(null); }} color="secondary">Cancelar</Button>
                        <Button onClick={handleImportCultura} color="primary">Importar</Button>
                    </ModalFooter>
                </Modal>

                {/* Modais INSEMINAÇÕES */}
                <Modal isOpen={openModalImportInseminacoes} onClose={handleCloseModalImportInseminacoes} aria-labelledby="modal-import-inseminacoes">
                    <ModalHeader id="modal-import-inseminacoes">Importar Inseminações - Selecione a Fazenda</ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label className="left" for="select_import_fazenda_inseminacoes">Selecione a Fazenda</Label>
                            {openModalImportInseminacoes &&
                                <Select
                                    classNamePrefix="select"
                                    value={renderOptionsFazendas().filter(option => option.value === (selectedImportFazendaInseminacoes || 0))}
                                    onChange={handleSelectImportFazendaInseminacoes}
                                    isSearchable
                                    placeholder="Selecione..."
                                    id="select_import_fazenda_inseminacoes"
                                    name="select_import_fazenda_inseminacoes"
                                    options={renderOptionsFazendas()}
                                />
                            }
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={handleCloseModalImportInseminacoes} color="secondary">Cancelar</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={openModalImportInseminacoesArquivo} onClose={() => setOpenModalImportInseminacoesArquivo(false)} aria-labelledby="modal-import-inseminacoes-arquivo">
                    <ModalHeader id="modal-import-inseminacoes-arquivo">Importar Inseminações - Selecionar Arquivo</ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <Label className="left" for="arquivo_import_inseminacoes_fazenda">Fazenda</Label>
                            <Input
                                id="arquivo_import_inseminacoes_fazenda"
                                label="Fazenda"
                                className="form-control"
                                value={(renderOptionsFazendas().find(o => o.value === selectedImportFazendaInseminacoes) || {}).label || ''}
                                readOnly
                            />
                        </FormGroup>

                        <FormGroup className="mt-3">
                            <p>
                                <span>Arquivo em formato Excel (.xls, .xlsx, .csv) contendo as Inseminações.</span><br />
                                <span>Arquivo de modelo: <a href="./modelo_importacao_inseminacoes.xlsx" target="_blank" download>Modelo de Importação de Inseminações</a></span>
                            </p>
                            <Label className="left" for="arquivo_import_inseminacoes">Arquivo</Label>
                            <Input
                                id="arquivo_import_inseminacoes"
                                label="Arquivo"
                                type="file"
                                onChange={handleSetImportFileInseminacoes}
                            />
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={() => { setOpenModalImportInseminacoesArquivo(false); setSelectedImportFileInseminacoes(null); }} color="secondary">Cancelar</Button>
                        <Button onClick={handleImportInseminacoes} color="primary">Importar</Button>
                    </ModalFooter>
                </Modal>

                {/* Modais PARTOS */}
                <Modal isOpen={openModalImportPartos} onClose={handleCloseModalImportPartos} aria-labelledby="modal-import-partos">
                    <ModalHeader id="modal-import-partos">Importar Partos - Selecione a Fazenda</ModalHeader>
                    <ModalBody><FormGroup><Label className="left" for="select_import_fazenda_partos">Selecione a Fazenda</Label>{openModalImportPartos && <Select classNamePrefix="select" value={renderOptionsFazendas().filter(option => option.value === (selectedImportFazendaPartos || 0))} onChange={handleSelectImportFazendaPartos} isSearchable placeholder="Selecione..." id="select_import_fazenda_partos" name="select_import_fazenda_partos" options={renderOptionsFazendas()} />}</FormGroup></ModalBody>
                    <ModalFooter><Button onClick={handleCloseModalImportPartos} color="secondary">Cancelar</Button></ModalFooter>
                </Modal>

                <Modal isOpen={openModalImportPartosArquivo} onClose={() => setOpenModalImportPartosArquivo(false)} aria-labelledby="modal-import-partos-arquivo">
                    <ModalHeader id="modal-import-partos-arquivo">Importar Partos - Selecionar Arquivo</ModalHeader>
                    <ModalBody>
                        <FormGroup><Label className="left" for="arquivo_import_partos_fazenda">Fazenda</Label><Input id="arquivo_import_partos_fazenda" label="Fazenda" className="form-control" value={(renderOptionsFazendas().find(o => o.value === selectedImportFazendaPartos) || {}).label || ''} readOnly /></FormGroup>
                        <FormGroup className="mt-3"><p><span>Arquivo em formato Excel (.xls, .xlsx, .csv) contendo os Partos.</span><br /><span>Arquivo de modelo: <a href="./modelo_importacao_partos.xlsx" target="_blank" download>Modelo de Importação de Partos</a></span></p><Label className="left" for="arquivo_import_partos">Arquivo</Label><Input id="arquivo_import_partos" label="Arquivo" type="file" onChange={handleSetImportFilePartos} /></FormGroup>
                    </ModalBody>
                    <ModalFooter><Button onClick={() => { setOpenModalImportPartosArquivo(false); setSelectedImportFilePartos(null); }} color="secondary">Cancelar</Button><Button onClick={handleImportPartos} color="primary">Importar</Button></ModalFooter>
                </Modal>

                {/* Modais PESAGENS */}
                <Modal isOpen={openModalImportPesagens} onClose={handleCloseModalImportPesagens} aria-labelledby="modal-import-pesagens">
                    <ModalHeader id="modal-import-pesagens">Importar Pesagens - Selecione a Fazenda</ModalHeader>
                    <ModalBody><FormGroup><Label className="left" for="select_import_fazenda_pesagens">Selecione a Fazenda</Label>{openModalImportPesagens && <Select classNamePrefix="select" value={renderOptionsFazendas().filter(option => option.value === (selectedImportFazendaPesagens || 0))} onChange={handleSelectImportFazendaPesagens} isSearchable placeholder="Selecione..." id="select_import_fazenda_pesagens" name="select_import_fazenda_pesagens" options={renderOptionsFazendas()} />}</FormGroup></ModalBody>
                    <ModalFooter><Button onClick={handleCloseModalImportPesagens} color="secondary">Cancelar</Button></ModalFooter>
                </Modal>

                <Modal isOpen={openModalImportPesagensArquivo} onClose={() => setOpenModalImportPesagensArquivo(false)} aria-labelledby="modal-import-pesagens-arquivo">
                    <ModalHeader id="modal-import-pesagens-arquivo">Importar Pesagens - Selecionar Arquivo</ModalHeader>
                    <ModalBody>
                        <FormGroup><Label className="left" for="arquivo_import_pesagens_fazenda">Fazenda</Label><Input id="arquivo_import_pesagens_fazenda" label="Fazenda" className="form-control" value={(renderOptionsFazendas().find(o => o.value === selectedImportFazendaPesagens) || {}).label || ''} readOnly /></FormGroup>
                        <FormGroup className="mt-3"><p><span>Arquivo em formato Excel (.xls, .xlsx, .csv) contendo as Pesagens.</span><br /><span>Arquivo de modelo: <a href="./modelo_importacao_pesagens.xlsx" target="_blank" download>Modelo de Importação de Pesagens</a></span></p><Label className="left" for="arquivo_import_pesagens">Arquivo</Label><Input id="arquivo_import_pesagens" label="Arquivo" type="file" onChange={handleSetImportFilePesagens} /></FormGroup>
                    </ModalBody>
                    <ModalFooter><Button onClick={() => { setOpenModalImportPesagensArquivo(false); setSelectedImportFilePesagens(null); }} color="secondary">Cancelar</Button><Button onClick={handleImportPesagens} color="primary">Importar</Button></ModalFooter>
                </Modal>

                {/* Modais PRODUÇÕES */}
                <Modal isOpen={openModalImportProducao} onClose={handleCloseModalImportProducao} aria-labelledby="modal-import-producao">
                    <ModalHeader id="modal-import-producao">Importar Produções - Selecione a Fazenda</ModalHeader>
                    <ModalBody><FormGroup><Label className="left" for="select_import_fazenda_producao">Selecione a Fazenda</Label>{openModalImportProducao && <Select classNamePrefix="select" value={renderOptionsFazendas().filter(option => option.value === (selectedImportFazendaProducao || 0))} onChange={handleSelectImportFazendaProducao} isSearchable placeholder="Selecione..." id="select_import_fazenda_producao" name="select_import_fazenda_producao" options={renderOptionsFazendas()} />}</FormGroup></ModalBody>
                    <ModalFooter><Button onClick={handleCloseModalImportProducao} color="secondary">Cancelar</Button></ModalFooter>
                </Modal>

                <Modal isOpen={openModalImportProducaoArquivo} onClose={() => setOpenModalImportProducaoArquivo(false)} aria-labelledby="modal-import-producao-arquivo">
                    <ModalHeader id="modal-import-producao-arquivo">Importar Produções - Selecionar Arquivo</ModalHeader>
                    <ModalBody>
                        <FormGroup><Label className="left" for="arquivo_import_producao_fazenda">Fazenda</Label><Input id="arquivo_import_producao_fazenda" label="Fazenda" className="form-control" value={(renderOptionsFazendas().find(o => o.value === selectedImportFazendaProducao) || {}).label || ''} readOnly /></FormGroup>
                        <FormGroup className="mt-3"><p><span>Arquivo em formato Excel (.xls, .xlsx, .csv) contendo as Produções.</span><br /><span>Arquivo de modelo: <a href="./modelo_importacao_producao.xlsx" target="_blank" download>Modelo de Importação de Produções</a></span></p><Label className="left" for="arquivo_import_producao">Arquivo</Label><Input id="arquivo_import_producao" label="Arquivo" type="file" onChange={handleSetImportFileProducao} /></FormGroup>
                    </ModalBody>
                    <ModalFooter><Button onClick={() => { setOpenModalImportProducaoArquivo(false); setSelectedImportFileProducao(null); }} color="secondary">Cancelar</Button><Button onClick={handleImportProducao} color="primary">Importar</Button></ModalFooter>
                </Modal>

                {/* Modais SECAGENS */}
                <Modal isOpen={openModalImportSecagens} onClose={handleCloseModalImportSecagens} aria-labelledby="modal-import-secagens">
                    <ModalHeader id="modal-import-secagens">Importar Secagens - Selecione a Fazenda</ModalHeader>
                    <ModalBody><FormGroup><Label className="left" for="select_import_fazenda_secagens">Selecione a Fazenda</Label>{openModalImportSecagens && <Select classNamePrefix="select" value={renderOptionsFazendas().filter(option => option.value === (selectedImportFazendaSecagens || 0))} onChange={handleSelectImportFazendaSecagens} isSearchable placeholder="Selecione..." id="select_import_fazenda_secagens" name="select_import_fazenda_secagens" options={renderOptionsFazendas()} />}</FormGroup></ModalBody>
                    <ModalFooter><Button onClick={handleCloseModalImportSecagens} color="secondary">Cancelar</Button></ModalFooter>
                </Modal>

                <Modal isOpen={openModalImportSecagensArquivo} onClose={() => setOpenModalImportSecagensArquivo(false)} aria-labelledby="modal-import-secagens-arquivo">
                    <ModalHeader id="modal-import-secagens-arquivo">Importar Secagens - Selecionar Arquivo</ModalHeader>
                    <ModalBody>
                        <FormGroup><Label className="left" for="arquivo_import_secagens_fazenda">Fazenda</Label><Input id="arquivo_import_secagens_fazenda" label="Fazenda" className="form-control" value={(renderOptionsFazendas().find(o => o.value === selectedImportFazendaSecagens) || {}).label || ''} readOnly /></FormGroup>
                        <FormGroup className="mt-3"><p><span>Arquivo em formato Excel (.xls, .xlsx, .csv) contendo as Secagens.</span><br /><span>Arquivo de modelo: <a href="./modelo_importacao_secagem.xlsx" target="_blank" download>Modelo de Importação de Secagens</a></span></p><Label className="left" for="arquivo_import_secagens">Arquivo</Label><Input id="arquivo_import_secagens" label="Arquivo" type="file" onChange={handleSetImportFileSecagens} /></FormGroup>
                    </ModalBody>
                    <ModalFooter><Button onClick={() => { setOpenModalImportSecagensArquivo(false); setSelectedImportFileSecagens(null); }} color="secondary">Cancelar</Button><Button onClick={handleImportSecagens} color="primary">Importar</Button></ModalFooter>
                </Modal>

                <ModalAnimaisPartos props={props} openModalAnimaisPartos={openModalAnimaisPartos} handleCloseModalAnimaisPartos={handleCloseModalAnimaisPartos} />
                <ModalAnimaisInseminacoes props={props} openModalAnimaisInseminacoes={openModalAnimaisInseminacoes} handleCloseModalAnimaisInseminacoes={handleCloseModalAnimaisInseminacoes} />
                <ModalProducoesPeriodo openModalProducoes={openModalProducoes} handleCloseModalProducoes={handleCloseModalProducoes} props={props} />
                <ModalProducoesLotePeriodo openModalProducoesLote={openModalProducoesLote} handleCloseModalProducoesLote={handleCloseModalProducoesLote} props={props} />
                <ModalTanquesPeriodo openModalTanques={openModalTanques} handleCloseModalTanques={handleCloseModalTanques} props={props} />
                <ModalNascimentos openModalNascimentos={openModalNascimentos} handleCloseModalNascimentos={handleCloseModalNascimentos} props={props} />
                <ModalRelatorioVisitas openModal={openModalRelatorioVisitas} handleClose={handleCloseModalRelatorioVisitas} props={props} />
            </Navbar >
        </div >
    );
}

export default NavBar;